import React, { useRef, useState } from "react";
import Avatar from "@mui/material/Avatar";

/**
 * The component to display a user profile image.
 * @param {string} imageUrl - The props passed to the component.
 * @returns The component to display a user profile image.
 */
const UserProfileImage = ({ imageUrl, userFullName, className }) => {
  const [selectedImage, setSelectedImage] = useState(
    imageUrl ?? "/assets/images/icon-profile.png",
  );
  const fileInputRef = useRef();

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditPicture = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      className={`relative shrink-0 ${className || "w-32 h-32"} rounded-full border-4 border-white dark:border-slate-800 shadow-md bg-white dark:bg-slate-800`}
    >
      <Avatar
        src={selectedImage}
        alt={userFullName}
        sx={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
      <button
        type="button"
        onClick={handleEditPicture}
        className="absolute bottom-0 right-0 bg-white dark:bg-slate-700 rounded-full p-1.5 shadow-sm border border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors"
        title="Upload new picture"
      >
        <img
          src="/assets/icons/image_upload_icon.svg"
          alt="edit"
          className="w-5 h-5 opacity-75 hover:opacity-100"
        />
      </button>
      <input
        type="file"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleImageUpload}
        accept="image/*"
      />
    </div>
  );
};

export default UserProfileImage;
